import React from "react";
import { useParams } from "react-router-dom";
import BusDetails from "../components/BusDetails";
import { sampleBuses } from "../lib/vehicles";
import { useTranslation } from "../lib/i18n";
import { useSeo } from "../lib/seo";

export default function BusDetailPage() {
  const { id } = useParams();
  const { t, lang } = useTranslation();

  const bus = sampleBuses.find((b) => b.id === id) ?? sampleBuses[0];
  if (!bus) return null;

  const title =
    lang === "lt"
      ? `Autobusų nuoma: ${bus.name} | Transrentus`
      : `Bus rental: ${bus.name} | Transrentus`;

  useSeo({ title, description: t("seoBusesDesc"), path: `/buses/${bus.id}`, lang });

  return <BusDetails bus={bus} />;
}
